<template>
  <div>
    <apexchart  v-if="!isLocked" type="bar" height="350" :options="chartOptions" :series="computedSeries" />
    <img v-if="isLocked" class="w-100" src="@/assets/images/blurredChart.png" alt="blurred image"  height="350" />
    <div class="custom-pagination" v-if="!isLocked && computedSeries.length">
      <button class="arrow-button" :disabled="currentPage === 1"  @click.prevent="prevPage" > ‹ </button>
      <span class="page-circle">{{ currentPage }}</span>
      <button class="arrow-button" :disabled="disableNext" @click.prevent="nextPage" > › </button>
    </div>
    <div class="chart-overlay" v-if="isLocked">
      <div class="overlay-text mt-5 mt-lg-0" style="padding-top: 150px;"> En attente de données ERP </div>
    </div>
</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'HorizentalBarChart',
  components: {
    apexchart: VueApexCharts
  },
  props: {
    labels: {
      type: Array,
      required: true
    },
    values: {
      type: Array,
      required: true
    },
    useColors: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: '#2ecc71'
    },
    colors: {
      type: Array,
      default: () => [
        '#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0',
        '#3F51B5', '#546E7A', '#D4526E', '#8D5B4C', '#F86624',
        '#2E294E', '#1B998B', '#9C27B0'
      ]
    },
    title: {
      type: String,
      default: ''
    },
    disableNext:{
      type: Boolean,
      default: false
    }, 
    currentPage: {
      type: Number,
      default: 1
    },
    itemsPerPage: {
      type: Number,
      default: 5
    },
    isLocked: {
      type: Boolean,
      default: false
    },
  },
  computed: {

    computedSeries() {
      return [
        {
          name: 'Value',
          data: this.values
        }
      ]
    },
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 4,
            barHeight: '50%',
            distributed: this.useColors
          }
        },
        colors: this.useColors ? this.colors : [this.color],
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return window.innerWidth < 576 ? '' : val 
          },
          style: {
            fontSize: '14px'
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val 
            }
          }
        },
        xaxis: {
          categories: this.labels
        },
        yaxis: {
          labels: {
            show: !this.useColors
          }
        },
        title: {
          text: this.title,
          align: 'center'
        }
      }
    },
  },
  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.$emit('page-changed', page, this.itemsPerPage);
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.onPageChange(this.currentPage - 1);
      }
    },
    nextPage() {
      if (!this.disableNext) {
        this.onPageChange(this.currentPage + 1);
      }
    }
  },
}
</script>
<style computed>
.custom-pagination {
  display: flex;
  align-items: right;
  justify-content: right;
  gap: 8px;
}

.page-circle {
  background-color: #1f3f93; 
  color: white;
  font-weight: bold;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.arrow-button {
  background: none;
  border: none;
  font-size: 20px;
  font-weight: bold;
  color: #1f3f93;
  cursor: pointer;
}

.arrow-button:disabled {
  color: #ccc;
  cursor: auto;
}



.chart-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  z-index: 2;
  background-color: #b2beea45; /* #00acc81f;   #00000042;*/
}

.overlay-text {
  font-size: 1.2em;
  color: #8f0404;
  font-weight: bold;
}
</style>